export default "__VITE_ASSET__BswBH$3E__"